import React from "react";
import * as Icon from "react-bootstrap-icons";
import "../assets/styles/SchoolHoverModal.scss";
import { generateOnePDFReport } from "../services/api";
import { poleType, setCenterType } from "../types/customTypes";
import { toast } from "react-toastify";
import { exportSchools } from "../services/pdfService";

const SchoolHoverModal:React.FC<propTypes> = (props: propTypes) => {

    const downloadReport = () => {
		const priority = JSON.parse(sessionStorage.getItem("priority"));
		props.controlImageCreation(true);

        Promise.all([
			createImageUrl(),
            generateOnePDFReport({
                schoolId: [props.school.school_Id],
                priorityFilterList: priority
            })
        ])
        .then(([imageUrls,response]) => {
            props.controlImageCreation(false);
            createPDF(response.schools, imageUrls);
        })
        .catch(error => {
            toast.error(error.toString());
        });
    };

	const createImageUrl = async () => {
        const imageUrls = [];
		const schoolName = props.school.school_Name;
		if (props.school.school_Name) {
            goToSchool();
            await new Promise(resolve => setTimeout(resolve, 1500)); // Wait for a short time
            const dataUrl = await props.getMapImage();

            imageUrls.push({ schoolName , dataUrl, schoolId : props.school.school_Id });
		}
        return imageUrls;
    };

	const createPDF = (pdfSchools, imageUrls) => {
        const schoolsData = pdfSchools.map(school => {
            school.image = imageUrls.find((img) => img.schoolName === school.schoolName);
            return school;
        });
        exportSchools(schoolsData);
    };

	const goToSchool = () => {
        props.setCenter({
            latitude: props.school.school_Latitude,
            longitude: props.school.school_Longitude,
            ...props.school,
        }, 17);
    };

    return (
        <div onMouseOver={props.onMouseOver} onMouseLeave={props.onMouseOut} data-testid="schoolHoverModal" className="card h-100 pole-marker border-0 p-0 SchoolHoverModal">
            <div className="poleinfo mt-1">
                <div className="floating-label mb-1">
                    <div className="label">School</div>
                    <div className="school-name mt-1" data-testid="schoolname">{props.school.school_Name}</div>
                </div>
                {/* <FloatingLabel title={props.school.school_Name} controlId="formControlSm" className="mb-2 ms-1" label="School" style={{ fontSize: '0.8rem' }} >
                        <Form.Control type="text" className="pe-1" defaultValue={props.school.school_Name} disabled />
                    </FloatingLabel> */}
                </div>
                <div className="footer d-flex justify-content-between mx-2 my-2">
                    <div className="circle p-2 border border-dark text-center" data-testid="low" style={{ backgroundColor: "yellow" }}>
                        {props.school.low}
                        {" "}
                    </div>

                    <div className="circle p-2 border border-dark text-center" data-testid="medium" style={{ backgroundColor: "orange" }}>{props.school.medium}</div>
                    <div className="circle p-2 border border-dark text-white bg-danger text-center" data-testid="high">{props.school.high}</div>
                </div>
                <div className="footer-btn mt-1 pointer" data-testid="downloadPdf-button" onClick={downloadReport}>
                    Report<Icon.Download className="icon mx-1" />
                </div>
                
        </div>
    );
}

type propTypes = {
	onMouseOver: () => void,
	onMouseOut: () => void,
	school: poleType,
    setCenter: setCenterType,
	controlImageCreation : (a) => void,
	getMapImage: () => void
};

export default SchoolHoverModal;
